




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class UploadDialog extends Vue {
  @Prop() uploadedFile!: any
  @Prop(Boolean) uploading!: Boolean
  @Prop() uploadError!: any

  handleReset () {
    this.$emit('reset-upload')
  }
}
